// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@media (max-width: 632px) {\n.el-date-range-picker {\n    left: 0!important;\n    max-width: 100vw;\n}\n}\n@media (max-width: 515px) {\n.el-date-range-picker {\n    overflow-x: auto;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
